import { SlideAdminWithUrls } from "shared/reducers/admin/adminSlideReducer";
import { shallowLeftDiff } from "shared/utils/formUtils";

export const submissionFieldsForSlide = (
  adminSlide: SlideAdminWithUrls,
  values?: SlideAdminWithUrls
) => {
  if (!values) values = adminSlide;
  return {
    case_id: values.case?.id || null,
    accession_number: values.accession_number || null,
    status: values.status || null,
    specimen_id: values.specimen?.id || null,
    block_obj_id: values.block_obj?.id || null,
    slide_number: values.slide_number || null,
    stain_id: values.stain_id || null,
    qc_status: values.qc_status || null,
    qc_notes: values.qc_notes || null,
    is_rescan: values.is_rescan || false,
    is_control: values.is_control || false,
    lab_id: values.lab?.id || null,
  };
};

export const shallowSlideComparison = (
  adminSlide: SlideAdminWithUrls,
  values: SlideAdminWithUrls
) => {
  const oldValues = submissionFieldsForSlide(adminSlide);
  const newValues = submissionFieldsForSlide(adminSlide, values);

  return shallowLeftDiff<ReturnType<typeof submissionFieldsForSlide>>(
    oldValues,
    newValues
  );
};
